export enum SignatureStatus {
    Awaiting = 1,
    Signed = 2,
    Declined = 3,
    Blocked = 4,
    Approval_approved = 5,
    Approval_reproved = 6,
    Filled = 7
}
